var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboWarningCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4935 3.90183C17.4935 3.90183 21.4459 8.45421 20.4268 13.6256C19.8078 16.778 17.2649 19.3209 14.1221 19.9304C8.95064 20.9495 4.39826 16.9971 4.39826 11.9971C4.39826 7.5304 8.02683 3.90183 12.4935 3.90183ZM12.4935 1.99707C6.59826 1.99707 1.8935 7.10183 2.56016 13.1399C3.06493 17.7114 6.78874 21.4352 11.3602 21.9399C17.3887 22.6066 22.503 17.9018 22.503 12.0066C22.4935 6.47326 18.0173 1.99707 12.4935 1.99707Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9932 6.24622H11.9932C11.717 6.24622 11.4932 6.4253 11.4932 6.64622V13.8462C11.4932 14.0671 11.717 14.2462 11.9932 14.2462H12.9932C13.2693 14.2462 13.4932 14.0671 13.4932 13.8462V6.64622C13.4932 6.4253 13.2693 6.24622 12.9932 6.24622Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9696 15.559H12.0172C11.7542 15.559 11.541 15.7722 11.541 16.0352V16.9875C11.541 17.2505 11.7542 17.4637 12.0172 17.4637H12.9696C13.2326 17.4637 13.4458 17.2505 13.4458 16.9875V16.0352C13.4458 15.7722 13.2326 15.559 12.9696 15.559Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboWarningCircle);
export default __webpack_public_path__ + "static/media/FBOWarningCircle.9bf560e83d4aeea0789dd62a3a7a65e2.svg";
export { ForwardRef as ReactComponent };